module.exports = __webpack_public_path__ + "static/media/Circo2025_06.0d445b08.webp";